import React from 'react';
import PropTypes from 'prop-types';
import MobileStep from './MobileStep';
import PrevStep from './PrevStep';
import Dictionary from '../../model/Dictionary';
import Exit from './Exit';

const MobileNavigation = ({ navigation, currentLocation, onClick, prevStep, exit }) => (
  <div className='mobile-navigation'>
    <div className='mobile-navigation-left'>
      <PrevStep
        className='mobile-prev'
        label={Dictionary.step.mobilePrev}
        prevStep={prevStep ? Dictionary.step[ prevStep.id.toLowerCase() ] : ''}
        step={prevStep}
        mobile
        onClick={onClick}
      />
    </div>
    <div className='mobile-navigation-stepper'>
      {navigation.map((step, index) => (
        <MobileStep
          key={`navigation-mobile-step-${step.id}-${index}`}
          goTo={step.id.toLowerCase()}
          stepId={step.id.toLowerCase()}
          onClick={onClick}
          enabled={step.enabled}
          mobile
          active={currentLocation.indexOf(step.id.toLowerCase()) === 1}
        />
      ))}
    </div>
    <div className='mobile-navigation-right'>
      <Exit exit={exit} label={Dictionary.step.exit} mobile />
    </div>
  </div>
);

MobileNavigation.propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.object),
  currentLocation: PropTypes.string,
  prevStep: PropTypes.object,
  exit: PropTypes.string,
  onClick: PropTypes.func,
};

export default MobileNavigation;



// WEBPACK FOOTER //
// ./src/components/navigation/MobileNavigation.js